import React, { useMemo } from 'react';

import { EnterDrawBare } from 'js/app/components/main/EnterDraw/EnterDraw';
import { Button } from 'js/components/common/Button';

import {
    useIsCategoryLoading
} from 'js/app/components/main/Games/components/GameCategory/components/GameList/hooks/useIsCategoryLoading';
import { ENTER_DRAW_ACTION } from 'js/app/components/main/Games/constants';
import { useCustomCategory } from 'js/app/components/main/Games/hooks/useCustomCategory';
import { useGamesSelector } from 'js/app/components/main/Games/store/context';
import { useTranslations } from 'js/hooks/i18n';

import { useHandlerActionClick } from './hooks/useHandlerActionClick';

import style from '../../CategoryTitle.scss';

export const CategoryLink = ({ category, targetCategoryName }) => {
    const { isShowBack } = useGamesSelector();
    const checkIsCategoryLoading = useIsCategoryLoading();
    const customCategory = useCustomCategory(targetCategoryName);
    const translate = useTranslations('playtech.mobile.system.buzzGame.');

    const isLoading = checkIsCategoryLoading(category);

    const { linkText, linkAction } = customCategory;

    const handleClickBtn = useHandlerActionClick({
        config: customCategory,
        targetCategoryName
    });

    const btnText = useMemo(() => {
        if (isShowBack) {
            return translate('back');
        }

        if (linkText) {
            return linkText;
        }

        return translate('viewAll');
    }, [isShowBack, linkText, translate]);

    return (
        linkAction === ENTER_DRAW_ACTION
            ? (
                <EnterDrawBare
                    isParseConfig
                    className={style.enterDrawLink}
                    {...customCategory}
                />
            )
            : (
                <Button
                    view="link"
                    className={style.link}
                    onClick={handleClickBtn}
                    disabled={isLoading && (linkAction === 'openCategory' || !linkAction)}
                >
                    {btnText}
                </Button>
            )
    );
};
